<template>
    <v-container>
        <v-footer class="d-flex flex-column" color="#273C5E" rounded="lg">
            <v-row class="mt-2">
                <strong>VLSM Calculator & Exercises</strong>
            </v-row>
            <v-row>
                <v-col cols="10" >
                    <strong>ArcuNet - Gabriarcu</strong>
                </v-col>
                <v-col cols="2" class="text-right">
                    <strong>{{ new Date().getFullYear() }}</strong>
                </v-col>
            </v-row>
        </v-footer>
    </v-container>

</template>
<script>
export default {
    name: 'AppFooter',
};
</script>